module.exports = __webpack_public_path__ + "static/media/MHRP29N0016.3dda1965.svg";